import React from 'react';
import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {withAuthenticationRequired} from "@auth0/auth0-react";
import Layout from "./layouts/Layout";
import PermissionProvider from "./features/employee/PermissionProvider";
import LoadingBlock from "./components/loader/LoadingBlock";
import Auth0Provider from "./features/auth/Auth0Provider";
import Loader from "./components/loader/Loader";
import QrCodeContextProvider from "./features/short-url-table/qr-code/QrCodeContextProvider";

const RedirectTable = React.lazy(() => import("./features/short-url-table/RedirectTable"))
const ErrorNotFound = React.lazy(() => import("./components/error/ErrorNotFound"))

function App() {
    return (
        <QrCodeContextProvider>
            <BrowserRouter>
                <Auth0Provider>
                    <Layout>
                        <PermissionProvider>
                            <React.Suspense fallback={<LoadingBlock/>}>
                                <Routes>
                                    <Route index element={<RedirectTable/>}/>
                                    <Route path={'*'} element={<ErrorNotFound/>}/>
                                </Routes>
                            </React.Suspense>
                        </PermissionProvider>
                    </Layout>
                </Auth0Provider>
            </BrowserRouter>
        </QrCodeContextProvider>
    );
}

export default withAuthenticationRequired(App, {
    onRedirecting: () => <Loader/>
});
